import { PropsWithChildren } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { motion, HTMLMotionProps } from 'motion/react';

export interface SlideContainerProps extends PropsWithChildren<HTMLMotionProps<'div'>> {
  css?: Interpolation<Theme>;
}

export const SlideContainer = ({ children, ...rest }: SlideContainerProps) => {
  return (
    <motion.div css={containerStyle} {...rest}>
      {children}
    </motion.div>
  );
};

const containerStyle = css({
  display: 'flex',
  height: '100%',
  overflowX: 'hidden',
  position: 'relative',
  transition: 'transform 0.5s ease',
});
